<script>
export default {
  name: 'LongTouch',
  inheritAttrs: true,
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    needCopy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      longTimer: null,
      preCopy: false
    };
  },
  methods: {
    /** 处理长按 */
    gotouchstart(e) {
      this.longTimer = setTimeout(() => {
        this.$emit('longTouch', e);
        if (this.needCopy) {
          this.preCopy = true;
        }
      }, 500);
    },
    /** 处理长按 */
    clearLongPressTimer() {
      this.longTimer && clearTimeout(this.longTimer);
      this.longTimer = null;
    },
    handleCopy(e) {
      e.stopPropagation();
      this.preCopy = false;
      this.$emit('copy');
    },
    handleClick(e) {
      e.stopPropagation();
      this.preCopy = false;
    }
  },
  render() {
    return this.$createElement(
      this.tag,
      {
        on: {
          touchstart: this.gotouchstart,
          touchmove: this.clearLongPressTimer,
          touchend: this.clearLongPressTimer,
          touchcancel: this.clearLongPressTimer,
          click: this.handleClick
        },
        style: {
          height: this.height,
          width: this.width
        },
        class: ['long-touch', this.needCopy && this.preCopy ? 'long-select' : '']
      },
      [
        this.$slots.default,
        this.needCopy
          ? this.$createElement(
              'div',
              {
                on: {
                  click: this.handleCopy
                },
                class: ['copy-btn', this.preCopy ? 'copy-btn-show' : ''],
                style: { 'white-space': 'nowrap' }
              },
              '复制'
            )
          : null
      ]
    );
  }
};
</script>
<style lang="less" scoped>
.long-touch {
  position: relative;
}
.long-select {
  background-color: #eee !important;
  > * {
    background-color: #eee !important;
  }
}
.copy-btn {
  display: none;
  position: absolute;
  background: #fff !important;
  left: calc(50% - 23px);
  top: 0;
  padding: 0 8px;
  border-radius: 4px;
  box-shadow: 0 6px 10px rgba(150, 150, 150, 0.25);
  min-width: 44px;
  text-align: center;
  &::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: calc(50% - 8px);
    border-width: 8px;
    border-color: #fff transparent transparent transparent;
    border-style: solid;
  }
}
.copy-btn-show {
  display: block;
}
</style>
